import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useVerifyEmailMutationMutation } from "../store/store/slices/MailRTK";
import { Button, Page, Spinner, Text } from "@shopify/polaris";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [verifyUserEmail, { isLoading, isError, isSuccess }] =
    useVerifyEmailMutationMutation();
  useEffect(() => {
    (async () => {
      const token = searchParams?.get("token") || "";
      await verifyUserEmail({ token });
    })();
  }, []);

  return (
    <Page>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <>
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <div>
                <Spinner
                  accessibilityLabel="Small spinner example"
                  size="small"
                />
              </div>
              <p style={{ transform: "translateY(-3px)" }}>
                Almost there! Verifying your email...
              </p>
            </div>
          )}
          {isSuccess && (
            <div>
              <Text as="span" fontWeight="bold" variant="headingLg">
                Email verification successfull...
              </Text>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <Button url="/login">Login</Button>
              </div>
            </div>
          )}
          {isError && (
            <div>
              <Text as="span" fontWeight="bold" variant="headingLg">
                Email verification Failed...
              </Text>
            </div>
          )}
        </>
      </div>
    </Page>
  );
};

export default VerifyEmail;
